import React from "react";
import { Transfer, Table, Empty } from "antd";
import difference from "lodash/difference";

// Customize Table Transfer
const TableTransfer = ({ loading = false, leftColumns, rightColumns, ...restProps }) => (
  <Transfer {...restProps} showSelectAll={false} operations={["Холбох", "Салгах"]} showSearch={true}>
    {({ direction, filteredItems, onItemSelectAll, onItemSelect, selectedKeys: listSelectedKeys }) => {
      const columns = direction === "left" ? leftColumns : rightColumns;

      const rowSelection = {
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows.map(({ key }) => key);
          const diffKeys = selected
            ? difference(treeSelectedKeys, listSelectedKeys)
            : difference(listSelectedKeys, treeSelectedKeys);
          onItemSelectAll(diffKeys, selected);
        },
        onSelect({ key }, selected) {
          onItemSelect(key, selected);
        },
        selectedRowKeys: listSelectedKeys,
      };

      return (
        <Table
          loading={loading}
          rowSelection={rowSelection}
          columns={columns}
          dataSource={filteredItems}
          size="small"
          onRow={({ key }) => ({
            onClick: () => {
              onItemSelect(key, !listSelectedKeys.includes(key));
            },
          })}
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Өгөгдөл хоосон байна." />,
          }}
        />
      );
    }}
  </Transfer>
);

export default TableTransfer;
